import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/')({
	beforeLoad: ({ context: { clerk }, location }) => {
		if (location.pathname !== '/') return

		if (!clerk.auth?.isSignedIn) {
			throw redirect({
				to: '/logout',
				search: {
					redirect: location.href,
				},
			})
		}

		throw redirect({
			to: '/home',
		})
	},
})
